'use client'

import { Heading, Paragraph } from '@graftcode/design-system'

import { GATEWAY_TELEMETRY_UNAVAILABLE_TEST_IDS } from '@modules/gateways/gateways-test-ids.const'

import { OpenTelemetryIcon } from '../icons/open-telemetry'

import liveOffIcon from './assets/live-off.svg'

import styles from './GatewayTelemetryUnavailable.module.scss'

type GatewayTelemetryUnavailableProps = {
  className?: string
}

export function GatewayTelemetryUnavailable({ className }: GatewayTelemetryUnavailableProps) {
  const rootClass = className ? `${styles.root} ${className}` : styles.root

  return (
    <div className={rootClass} data-testid={GATEWAY_TELEMETRY_UNAVAILABLE_TEST_IDS.root}>
      <div className={styles.panel}>
        <div className={styles.message}>
          <div className={styles.iconCircle} aria-hidden="true">
            {/* eslint-disable-next-line @next/next/no-img-element -- static SVG import */}
            <img src={liveOffIcon.src} alt="" width={24} height={24} className={styles.liveOffIcon} />
          </div>

          <div className={styles.text}>
            <Heading type="h4" className={styles.title}>
              Telemetry isn&apos;t connected
            </Heading>
            <Paragraph size="sm" className={styles.description}>
              Connect OpenTelemetry to view uptime, traffic and active connections.
            </Paragraph>
          </div>

          <button type="button" disabled className={styles.configureButton}>
            <OpenTelemetryIcon size={20} active={false} className={styles.configureButtonIcon} />
            <span className={styles.configureButtonText}>Configure OpenTelemetry (Coming Soon)</span>
          </button>
        </div>
      </div>
    </div>
  )
}
